import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "person-add",
  "use": "person-add-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"person-add\"><path d=\"M9 12c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 8c2.67 0 8 1.34 8 4v2H1v-2c0-2.66 5.33-4 8-4zm6 4c-.22-.72-3.31-2-6-2-2.7 0-5.8 1.29-6 2zm3-3v-3h-3v-2h3V7h2v3h3v2h-3v3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol